import {
  LabeledValue,
  type LabeledValueProps,
} from "@risalabs_frontend_org/oasis-ui-kit";

export type EvCoverageFinancialLabeledValueProps = Pick<
  LabeledValueProps,
  | "label"
  | "value"
  | "className"
  | "isEditable"
  | "editAs"
  | "onValueChange"
  | "inputProps"
  | "required"
>;

/** Vertical money/value row styling for deductible, OOP, and copay SummaryCards. */
export const EvCoverageFinancialLabeledValue = (
  props: EvCoverageFinancialLabeledValueProps,
) => (
  <LabeledValue
    direction="vertical"
    gap={4}
    labelClassName="!text-[0.6875rem] !font-normal !leading-4 !text-primaryGray-6"
    valueClassName="!text-sm !font-bold !leading-5 !text-primaryGray-1"
    {...props}
  />
);
